const MAX = 500;
const R = 118;
const ARC = 0.75;
const FULL = 2 * Math.PI * R;
const TICKS = [0, 5, 10, 25, 50, 100, 250, 500];
const scale = (v) => Math.min(Math.log10(1 + v) / Math.log10(1 + MAX), 1);

const tickPos = (v, r) => {
  const a = ((135 + scale(v) * 270) * Math.PI) / 180;
  return [150 + r * Math.cos(a), 150 + r * Math.sin(a)];
};

export const Gauge = ({ value = 0, phase, unit = "Mbps", running }) => {
  const pct = scale(value);
  return (
    <div className={`relative w-[310px] h-[310px] mx-auto ${running ? "gauge-live" : ""}`} data-testid="speed-gauge">
      <div className="absolute inset-8 rounded-full bg-[#007AFF]/10 blur-3xl" />
      <svg viewBox="0 0 300 300" className="relative w-full h-full">
        <defs>
          <linearGradient id="g-arc" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0%" stopColor="#00C6FF" />
            <stop offset="100%" stopColor="#007AFF" />
          </linearGradient>
        </defs>
        <g transform="rotate(135 150 150)">
          <circle cx="150" cy="150" r={R} fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="16" strokeLinecap="round"
            strokeDasharray={`${FULL * ARC} ${FULL}`} />
          <circle cx="150" cy="150" r={R} fill="none" stroke="url(#g-arc)" strokeWidth="16" strokeLinecap="round"
            strokeDasharray={`${Math.max(FULL * ARC * pct, 0.01)} ${FULL}`}
            style={{ transition: "stroke-dasharray 250ms ease-out", filter: "drop-shadow(0 0 10px rgba(0,122,255,0.7))" }} />
        </g>
        {TICKS.map((t) => {
          const [x, y] = tickPos(t, 92);
          return <text key={t} x={x} y={y} fill="#6b6b75" fontSize="10" textAnchor="middle" dominantBaseline="middle" fontFamily="Outfit">{t}</text>;
        })}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-[11px] uppercase tracking-[0.25em] text-[#7cc4ff]" data-testid="gauge-phase">{phase || "Ready"}</span>
        <span className="font-rounded font-semibold text-6xl leading-none mt-2 tabular-nums" data-testid="gauge-value">
          {value ? value.toFixed(1) : "0.0"}
        </span>
        <span className="text-xs text-neutral-400 mt-2">{unit}</span>
      </div>
    </div>
  );
};
